<template>
  <b-card>
    <div
      v-if="loadingData"
      class="d-flex justify-content-center "
    >
      <b-spinner
        type="grow"
        label="Spinning"
      />
    </div>
    <validation-observer
      v-if="!loadingData"
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="Name"
          >
            <b-form-group
              label="name"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="delegator.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="email"
          >
            <b-form-group
              label="email"
              label-for="email"
            >
              <b-form-input
                v-model="delegator.email"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="phone"
          >
            <b-form-group
              label="phone"
              label-for="phone"
            >
              <b-form-input
                v-model="delegator.phone"
                trim
                placeholder="phone"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6" />
        <b-col md="6">
          <b-form-group
            label="Signature (PNG only)"
            label-for="signature"
          >
            <b-form-file
              id="signature"
              accept="image/png,.png"
              placeholder="Choose a PNG file..."
              drop-placeholder="Drop PNG here..."
              @change="onFileChange($event, 'signature')"
            />
            <small
              v-if="fileErrors.signature"
              class="text-danger"
            >
              {{ fileErrors.signature }}
            </small>
            <div
              v-if="signaturePreview"
              class="mt-1"
            >
              <b-img
                :src="signaturePreview"
                width="120"
                thumbnail
                alt="Signature preview"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Stamp (PNG only)"
            label-for="stamp"
          >
            <b-form-file
              id="stamp"
              accept="image/png,.png"
              placeholder="Choose a PNG file..."
              drop-placeholder="Drop PNG here..."
              @change="onFileChange($event, 'stamp')"
            />
            <small
              v-if="fileErrors.stamp"
              class="text-danger"
            >
              {{ fileErrors.stamp }}
            </small>
            <div
              v-if="stampPreview"
              class="mt-1"
            >
              <b-img
                :src="stampPreview"
                width="120"
                thumbnail
                alt="Stamp preview"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0 || hasFileErrors"
            @click="addDelegator()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      loader: false,
      loadingData: false,
      errors: {},
      signatureFile: null,
      stampFile: null,
      signaturePreviewUrl: '',
      stampPreviewUrl: '',
      fileErrors: {
        signature: '',
        stamp: '',
      },
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const delegator = ref({})

    return {
      getValidationState,
      delegator,
    }
  },
  computed: {
    signaturePreview() {
      return this.signaturePreviewUrl || this.delegator.signature || null
    },
    stampPreview() {
      return this.stampPreviewUrl || this.delegator.stamp || null
    },
    hasFileErrors() {
      return Boolean(this.fileErrors.signature || this.fileErrors.stamp)
    },
  },
  beforeDestroy() {
    this.revokePreviewUrl('signature')
    this.revokePreviewUrl('stamp')
  },
  mounted() {
    this.showDelegator()
  },
  methods: {
    isPngFile(file) {
      if (!file) return false
      const isPngType = file.type === 'image/png'
      const isPngName = /\.png$/i.test(file.name)
      return isPngType || isPngName
    },
    revokePreviewUrl(field) {
      const previewKey = `${field}PreviewUrl`
      if (this[previewKey]) {
        URL.revokeObjectURL(this[previewKey])
        this[previewKey] = ''
      }
    },
    onFileChange(event, field) {
      const file = event.target.files?.[0] || null
      this.fileErrors[field] = ''
      this.revokePreviewUrl(field)

      if (!file) {
        this[`${field}File`] = null
        return
      }

      if (!this.isPngFile(file)) {
        this.fileErrors[field] = 'Only PNG files are allowed.'
        this[`${field}File`] = null
        const input = event.target
        if (input) input.value = ''
        return
      }

      this[`${field}File`] = file
      this[`${field}PreviewUrl`] = URL.createObjectURL(file)
    },
    async showDelegator() {
      if (this.$route.params.id) {
        this.loadingData = true
        await axios.get(`delegator/signed/${this.$route.params.id}`).then(res => {
          this.delegator = decryptData(res.data.payload).data.delegator
        })
      } else {
        this.loadingData = false
        return false
      }
      this.loadingData = false
      return true
    },
    addDelegator() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()

        const skipKeys = ['signature', 'stamp']
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in this.delegator) {
          if (!skipKeys.includes(key)) {
            const value = this.delegator[key]
            if (value != null && typeof value !== 'object') {
              formData.append(key, value)
            }
          }
        }

        if (this.signatureFile) {
          formData.append('signature', this.signatureFile)
        }
        if (this.stampFile) {
          formData.append('stamp', this.stampFile)
        }

        axios.post(`delegator/signed/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'delegator' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            const payload = decryptData(error.response.data.payload).message
            this.$toast({
              component: ToastificationContent,
              props: {
                title: payload,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
